import { useTranslation } from "react-i18next";

import ErrorBlock from "@krea/customer-features/shared-components/error-block";

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <ErrorBlock
      status={404}
      title={t("errors.404.heading")}
      description={t("errors.404.subheading")}
    />
  );
};
